<div [formGroup]="form">
  <label
    for="{{ item.formControlName }}"
    class="custom-form-field__label"
  >{{ item.label }}</label>
  <p-calendar
    [inputId]="item.formControlName"
    [showIcon]="true"
    [placeholder]="item.placeholder && item.placeholder !== 'undefined' ? item.placeholder : ''"
    [formControlName]="item.formControlName"
    [mask]="'DATE_MASK' | translate"
    [firstDayOfWeek]="1"
    [minDate]="minDate"
    [maxDate]="maxDate"
    (change)="dateBinding(item.formControlName, $event)"
    appendTo="body"
  ></p-calendar>
</div>
